import config from './package.json';
import webinarReducer from './reducers/webinarReducer';
import { webinarSaga } from './sagas/webinarSaga';
import { ModuleConfig } from '../../types/configTypes';

export default {
  config,
  routes: {},
  reducers: {
    webinar: {
      reducer: webinarReducer,
    },
  },
  sagas: [webinarSaga],
} as ModuleConfig;
